"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProctorTest = void 0;
const react_1 = __importDefault(require("react"));
/**
 * Component for conditionally rendering elements based on the value of a Proctor Test name.
 *
 * <p>Example:
 *
 * <pre>
 *     const my_proctor_tst = {
 *       fallbackValue: -1,
 *       buckets: {
 *           inactive: -1,
 *           control: 0,
 *           active: 1
 *       }
 *     };
 *     const specifications = { my_proctor_tst };
 *     const proctorGroups = { my_proctor_tst: { value: 1 } };
 *
 *     return (
 *         <ProctorTest
 *               testName={'my_proctor_test'}
 *               specifications={specifications}
 *               proctorGroups={proctorGroups}
 *               buckets={{
 *                   inactive: () => <div>inactive</div>,
 *                   control: () => <div>control</div>,
 *                   active: () => <div>active</div>
 *               }}
 *          />
 *     );
 * </pre>
 *
 * <p>If you would like to reduce the duplication of the {@link #specifications} and {@link #proctorGroups} props
 * in this component, take a look at the {@link #createProctorTest} function.
 */
exports.ProctorTest = (props) => {
    var _a;
    const onError = (_a = props.onError) !== null && _a !== void 0 ? _a : (() => react_1.default.createElement(react_1.default.Fragment, null));
    const proctorGroup = props.proctorGroups[props.testName];
    const specification = props.specifications[props.testName];
    if (!proctorGroup) {
        return onError(new Error(`In Proctor '${props.testName}' no proctor group value was found`));
    }
    if (!specification) {
        return onError(new Error(`In Proctor '${props.testName}' no specification was found`));
    }
    const testBuckets = specification.buckets;
    if (!testBuckets) {
        return onError(new Error(`In Proctor '${props.testName}' no buckets found in specification`));
    }
    let bucketName = null;
    for (const testBucketName in testBuckets) {
        if (testBuckets.hasOwnProperty(testBucketName) && testBuckets[testBucketName] === proctorGroup.value) {
            bucketName = testBucketName;
            break;
        }
    }
    if (!bucketName) {
        return onError(new Error(`In Proctor '${props.testName}' no bucket found with value '${proctorGroup.value}'`));
    }
    const rendererFunction = props.buckets[bucketName];
    if (!rendererFunction) {
        return onError(new Error(`In Proctor '${props.testName}' no renderer function found for bucket '${bucketName}'`));
    }
    return rendererFunction(proctorGroup);
};
exports.ProctorTest.displayName = 'ProctorTest';
